/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {gsap} from "gsap";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {LonerGameMode} from "../server/LonerGameMode";
import {IFadeTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {IWinRatioConfig, LonerWinConfigs} from "../configs/LonerWinConfigs";
import {Loner} from "../Loner";
import {LoopableList} from "../utils/LoopableList";

export class LonerSound {
    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";

    public static START_GAME: string = "gameIntroOneShot";
    public static SPLASH_INTRO_LOOP: string = "splashIntroLoop";
    public static BIG_SYMBOL_LAND: string = "wildBigLand";
    public static TV_LAND: string = "tvLandReveal";
    public static TV_SPLIT: string = "tvSplit";
    public static TV_WILD: string = "tvWild";
    public static TV_INFECT: string = "xWaysInfectiousMultipleSmall";
    public static TV_INFECT_LAST: string = "xWaysInfectiousLastOne";
    public static TTB_ACTIVATION: string = "tickTickBoomActivation";
    public static SSD_ACTIVATION: string = "shootShootDuckActivation";
    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: string[] = ["reelLanding1", "reelLanding1", "reelLanding1", "reelLanding1", "reelLanding1"];
    public static MAIN_GAME_MUSIC: string = "background-music-main";
    public static COUNT_UP: string = "countup";
    public static COUNT_UP_END_TINY: string = "countupEndsTiny";
    public static COUNT_UP_END_SMALL: string = "countupEndsSmall";
    public static COUNT_UP_END_MEDIUM: string = "countupEndsMedium";
    public static COUNT_UP_END_LARGE: string = "countupEndsLarge";
    public static MULTIPLIER_COUNT_UP_BIG: string = "";
    public static BIG_WIN_PRE:string = "pleaseStandBy";
    public static BIG_WIN_LEVEL_CHANGE: string = "bigwinLevelChange";
    public static BIG_WIN_START: string = "bigwinIntro";
    public static BIG_WIN_MUSICS: string[] = ["bigwin1", "bigwin2", "bigwin3", "bigwin4", "bigwin5"];
    public static BIG_WIN_MUSIC_END: string = "bigwinEnds";
    public static BIG_WIN_HIGHLIGHT: string[] = ["bigWinWinHighlight1", "bigWinWinHighlight2", "bigWinWinHighlight3"];
    public static CONTINUE_BUTTON: string = "continueButton";
    public static XBET_ON: string = "xBetOn";
    public static XBET_OFF: string = "xBetOff";
    public static SCATTER_1_LAND: string = "tvSingle1";
    public static SCATTER_2_LAND: string = "tvSingle2";
    public static SCATTER_3_LAND: string = "tvSingle3";
    public static SCATTER_ANTICIPATION: string = "tvAnticipation";
    public static SCATTER_ANTICIPATION_FAIL:string="tvAnticipationFail";
    public static TRANSITION_STATIC_POST_FEATURE: string = "transitionStaticPostFeature";
    public static MAIN_GAME_MAX_WIN_SYM_LAND:string="maxWinSymbolLand";

    //Win sounds
    public static WIN_BLINK: string = "winHighlight";
    public static WIN_HIGHLIGHT:LoopableList<string>=new LoopableList<string>(["winBlink1","winBlink2"]).setRandomizeAtWrapAround(false);

    //Tick Tick Boom
    public static TTB_CAR_EXPLODE: string = "tickTickBoomEnd";
    public static TTB_COUNTUP: string = "tickTickBoomCountUp";
    public static TTB_COUNTUP_END: string = "tickTickBoomCountUpEnd";
    public static TTB_BACK_TO_MAIN: string = "tickTickBoomBackToMainGame";
    public static TTB_INTRO_MUSIC: string = "tickTickBoomIntroLoop";
    public static TTB_OUTRO_MUSIC: string = "tickTickBoomOutroLoop";
    public static TTB_MUSIC: string = "tickTickBoomLoop";
    public static TTB_SELECT: string = "tickTickBoomClickOnTarget";
    public static TTB_CAR_START: string = "tickTickBoomCarStartCloud";
    public static TTB_CAR_DRIVING: string = "tickTickBoomCarDriving";
    public static TTB_CAR_ON_FIRE: string = "tickTickBoomCarOnFire";

    //Pin The Win
    public static PTW_ACTIVATION: string = "pinTheWinActivation";
    public static PTW_INTRO_LOOP: string = "pinTheWinIntroLoop";
    public static PTW_LOOP: string = "pinTheWinLoop";
    public static PTW_BOUNCE: string = "pinTheWinBounce";
    public static PTW_LOW_WIN: string = "pinTheWinWinLow";
    public static PTW_MID_WIN: string = "pinTheWinWinMedium";
    public static PTW_HIGH_WIN: string = "pinTheWinWinHigh";
    public static PTW_OUTRO_CONTINUE_BTN: string = "pinTheWinContinueToMainGame";
    public static PTW_INTRO_CONTINUE_BTN: string = "pinTheWinContinueButtonStart";
    public static PTW_OUTRO_LOOP: string = "pinTheWinFsOutroLoop";
    public static PTW_MAX_WIN_SYM_BLINK: string = "pinTheWinMaxWinBlink";


    //Kill The Woke
    public static KTW_MUSIC: string = "killTheWokeLoop";

    //Shoot Shoot Duck
    public static SSD_INTRO_MUSIC: string = "fsIntro";
    public static SSD_MUSIC: string = "shootShootDuckLoop";
    public static SSD_NORMAL_DUCK_SHOOT_SOUNDS: string[] = ["shootDuckShot1", "shootDuckShot2", "shootDuckShot3", "shootDuckShot4"];
    public static SSD_MISS_DUCK_SHOOT_SOUNDS:LoopableList<string> = new LoopableList<string>([
        "shootDuckShotMiss1",
        "shootDuckShotMiss2",
        "shootDuckShotMiss3"
    ]).setRandomizeAtWrapAround(true);
    public static SSD_VAN_SHOOT_SOUND: string = "shootDuckVan";
    public static SSD_BOMB_SHOOT_SOUND: string = "shootDuckBomb";
    public static SSD_AMMO_SHOOT_SOUND: string = "shootDuckAmmo";
    public static SSD_MISS_SHOOT_SOUND: string = "";
    public static SSD_INITIAL_IMPACT_SOUND: string = "shootShootDuckFsOutroInitialImpact";
    public static SSD_BACK_TO_MAIN: string = "shootShootDuckContinueBackToMainGame";
    public static SDD_LOOP: string = "shootShootDuckReelSpinSound";
    public static SSD_VAN_MULTI_UPDATE:string="shootShootDuckVanMultiUpdate";
    public static SSD_LAST_AMMO_LEFT:string="shootShootDuckLastAmmoBlink";
    public static SSD_COUNT_UP_END:string="countupEndsShootShootDuck";
    public static SSD_OUTRO_LOOP:string="shootShootDuckOutroLoop";
    public static SSD_COUNTUP: string = "shootShootDuckMultiCountUp";
    public static SSD_COUNTUP_END: string = "shootShootDuckMultiUpdate";
    public static SSD_MAX_SYM_PASSING_BY:string="shootShootDuckMaxWinDuckPassingBy";
    public static SSD_MAX_SYM_SHOOT:string="shootDuckMaxWin";

    //God mode
    public static GM_LOOP_SOUNDS: string[] = ["godModeLoop1", "godModeLoop2", "godModeLoop3", "godModeLoop4"];
    public static GM_LETTER_M: string = "godModeM";
    public static GM_LETTER_A: string = "godModeA";
    public static GM_LETTER_X: string = "godModeXLand";
    public static GM_THIRD_MONITOR_LAND: string = "godModeThirdMonitor";
    public static GM_WIN_LOOP: string = "godModeWinLoop";
    public static GM_NO_WIN_SOUND: string[] = ["godModeNoWin1", "godModeNoWin2", "godModeNoWin3", "godModeNoWin4"];
    public static GM_BACK_TO_MAIN_GAME: string = "godModeBackToMainGame";
    public static GM_START_SOUND: string = "godModeStart"

    private _currentMusic: string;
    private _player: NolimitAudioPlayer;
    private _previousSound: string;
    private _stopRepeatSoundTL: gsap.core.Timeline;
    private _stopRepeatSound: boolean;

    constructor() {
        this._player = <NolimitAudioPlayer>SlotGame.sound;
        this._stopRepeatSoundTL = gsap.timeline();
        this._stopRepeatSoundTL.add((): void => {
            this._previousSound = "";
            this._stopRepeatSound = false;
        }, "+=0.1");
    }

    public playSound(name: string, volume?: number, repeat?: number): NolimitHowl | undefined {
        if (this._previousSound == name && this._stopRepeatSound == true) {
            return undefined;
        } else {
            this._previousSound = name;
            this._stopRepeatSound = true;
            this._stopRepeatSoundTL.restart();
            Logger.logDev("------- Play sound: " + name);
            return this._player.playTrack({name: name, volume: volume, repeat: repeat});
        }
    }

    public stopGodModeResultLoop(): void {
        for (let idx: number = 0; idx < LonerSound.GM_LOOP_SOUNDS.length; idx++) {
            if (this._player.fetchSoundPlayer(LonerSound.GM_LOOP_SOUNDS[idx])?.isPlaying) {
                this.stopSound(LonerSound.GM_LOOP_SOUNDS[idx]);
            }
        }
    }

    public playNonLoopSound(name: string): void {
        Logger.logDev("------- Play non loop sound: " + name);
        this._player.playTrack({name: name})?.setLoop(false);
    }

    public fadeMusic(from: number, to: number, duration: number) {
        Logger.logDev(`------- fade music sound: ${from} ${to} ${duration}`);
        if (this._currentMusic != "") {
            const currentMusicHowl = this._player.fetchSoundPlayer(this._currentMusic);
            if (currentMusicHowl) {
                currentMusicHowl.fade(from, to, duration);
            } else {
                Logger.warn("Music not found for fading.");
            }
        }
    }

    public stopSound(name: string): NolimitHowl | undefined {
        Logger.logDev("------- stop sound: " + name);
        return this._player.stopTrack(name);
    }

    public fadeAndStopSound(fadeOutConf: IFadeTrackConf): void {
        const fade: NolimitHowl | undefined = this._player.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    this._player.stopTrack(fadeOutConf.name);
                }
            });
        } else {
            this._player.stopTrack(fadeOutConf.name);
        }
    }

    public switchMusic(mode: LonerGameMode | string, fadeOutConf?: IFadeTrackConf, fadeInConf?: IFadeTrackConf) {
        let nextMusic: string = "";

        switch (mode) {
            case LonerSound.SSD_INTRO_MUSIC:
                nextMusic = LonerSound.SSD_INTRO_MUSIC;
                break;
            case LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK:
                nextMusic = LonerSound.SSD_MUSIC;
                break;
            case LonerGameMode.FEATURE_PIN_THE_WIN:
                nextMusic = LonerSound.PTW_LOOP;
                break;
            default:
                nextMusic = LonerSound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        if (this._currentMusic !== null) {
            const fadeName: string = this._currentMusic;
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade: NolimitHowl | undefined = this._player.fadeTrack(fadeOutConf);
                if (fade) {
                    gsap.to(this, {
                        duration: fadeOutConf.duration / 1000, onComplete: () => {
                            this._player.stopTrack(fadeName);
                        }
                    });
                } else {
                    this._player.stopTrack(fadeName);
                }
            } else {
                this._player.stopTrack(fadeName);
            }
        }

        Logger.logDev("------- Switching sound from: " + this._currentMusic + " to: " + nextMusic);

        this._player.playTrack({name: nextMusic, volume: 1});
        if (fadeInConf) {
            fadeInConf.name = nextMusic;
            this._player.fadeTrack(fadeInConf);
        }
        this._currentMusic = nextMusic;
    }

    public startCountUp(): void {
        this.playSound(LonerSound.COUNT_UP, 1, 10000);
    }

    public startTTBCountUp(): void {
        this.playSound(LonerSound.TTB_COUNTUP, 1, 10000);
    }

    public startSSDCountUp(): void {
        this.playSound(LonerSound.SSD_COUNTUP, 1, 10000);
    }

    public startPTWCountUp(): void {
        this.playSound(LonerSound.TTB_COUNTUP, 1, 10000);
    }

    public stopPTWCountUp() {
        this.stopSound(LonerSound.TTB_COUNTUP);
        this.playSound(LonerSound.TTB_COUNTUP_END);
    }

    public stopSSDCountUp() {
        this.stopSound(LonerSound.SSD_COUNTUP);
        this.playSound(LonerSound.SSD_COUNTUP_END);
    }

    public stopTTBCountUp() {
        this.stopSound(LonerSound.TTB_COUNTUP);
        this.playSound(LonerSound.TTB_COUNTUP_END);
    }

    public stopCountUp(config?: IWinRatioConfig, playEndSound: boolean = true) {
        this.stopSound(LonerSound.COUNT_UP);
        if (playEndSound) {
            let sound: string = LonerSound.COUNT_UP_END_LARGE;

            if (config) {
                if (config.type == LonerWinConfigs.TINY) {
                    sound = LonerSound.COUNT_UP_END_TINY;
                } else if (config.type == LonerWinConfigs.SMALL) {
                    sound = LonerSound.COUNT_UP_END_SMALL;
                } else if (config.type == LonerWinConfigs.MEDIUM) {
                    sound = LonerSound.COUNT_UP_END_MEDIUM;
                } else if (config.type == LonerWinConfigs.BIG_WIN_06) {
                    sound = "";
                }
            }
            if(Loner.model.mode===LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK && Loner.model.nextMode===LonerGameMode.NORMAL){
                sound=LonerSound.SSD_COUNT_UP_END;
            }

            this.playSound(sound);
        }
    }

    get player(): NolimitAudioPlayer {
        return this._player;
    }
}